import { atomWithStorage } from 'jotai/utils'
import { defaultTheme } from 'config/themes/defaultTheme'

export const globalThemeAtom = atomWithStorage('globalTheme', JSON.parse(JSON.stringify(defaultTheme)))
